import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { LoginGuard } from '@common/guards/login/login.guard';
import { AuthGuard } from './guards/auth/auth.guard';

const routes: Routes = [
    {
        path: 'login',
        canActivate: [LoginGuard],
        loadChildren: () => import('@auth/authentication.module').then(module => module.AuthenticationModule)
    },
    {
        path: 'logout',
        loadChildren: () => import('@auth/authentication.module').then(module => module.AuthenticationModule)
    },
    {
        path: 'edp/token',
        redirectTo: 'login/redirect'
    },
    {
        path: '',
        canActivate: [AuthGuard],
        canLoad: [AuthGuard],
        loadChildren: () => import('@app/application.module').then(module => module.ApplicationModule)
    },
    {
        path: '**',
        redirectTo: '',
        pathMatch: 'full'
    }
];

@NgModule({
    imports: [
        RouterModule.forRoot(routes, {
            paramsInheritanceStrategy: 'always',
            enableTracing: false
        })
    ],
    exports: [RouterModule]
})
export class BootstrapRoutingModule {}
